import Loadable from 'react-loadable'
import { Component } from 'react'

import Loading from 'components/modulor/loading'

LoadableComponent = Loadable
  loader: -> `import('./page_tree' /* webpackChunkName: "page_tree" */)`,
  loading: -> <Loading />

export default class LoadablePageTree extends Component
  render: -> <LoadableComponent {...this.props} />
